import React from "react";
import { fetchAppUsers, fetchRequestListData } from "../UtilityFunctions/CommonFunction";
import { GetAllBusinessUnitName } from "../Fetchers/HomeRequest";
import moment from "moment";
import { Callout, DatePicker, DefaultButton, Dialog, Label, mergeStyleSets, SearchBox } from "office-ui-fabric-react";
import { Dismiss32Filled } from "@fluentui/react-icons";
import Select from "react-select";
import { customStyles } from "../UtilityFunctions/ReactSelectStyles";
import { initializeIcons, PrimaryButton } from "@fluentui/react";
// import { initializeIcons } from "office-ui-fabric-react";
import { v4 as uuid } from "uuid";
import ContextService from "../../services/ContextService";
import axios from "axios";
import { SweetAlerts } from "../UtilityFunctions/SweetAlerts";
import { isArrayValidated, isStringValidated } from "../Global/constants";
import TextField from '../UtilityFunctions/CustomTextField';
let allData = [];
function AdhocTaskPane({SettingsListData}) {
  const hideSampleData = JSON.parse(SettingsListData?.RequestContractSampleData || '{}')?.RequestSampleData === 'No';
  const CurrentUser = JSON.parse(localStorage.getItem("CurrentUser")||"{}")
  const [requestData, setRequestData] = React.useState([]);
  const [UserOptions, setUserOptions] = React.useState<any>([]);
  const [isTaskOpen, setisTaskOpen] = React.useState<boolean>(false);
  const [calloutID, setcalloutID] = React.useState("");
  const { SweetAlert: SweetalertsTask } = SweetAlerts("#SweetalertsAddTask");
  const { SweetAlert: SweetalertCallout } = SweetAlerts("#alertCallout");
  const [TaskData, setTaskData] = React.useState({
    TaskTitle:"",
    DueDate:null,
    AssignedTo:[],
    AssignedToName:[],
    Remarks:"",
    RequestData:{}
  });
  React.useEffect(() => {
    initializeIcons()
    fetchData()
  }, []);
const fetchData=async()=>{
  const usersOptions=await fetchAppUsers();
  const Busunitdata = await GetAllBusinessUnitName({});
  const allusers=[]
  usersOptions?.map((user)=>{
    allusers.push({
      key: user.id,
      text: user?.text,
      value: user.key,
      label: user?.text,
    })
  })
  setUserOptions(allusers)
  await getAllRequestData(Busunitdata || {});
}
  const stylesCallout = mergeStyleSets({
    callout: {
      width: 300,
      maxWidth: "90%",
      height: 300,
      padding: "8px 8px",
      background: "var(--settingsCardBackground) !important",
      overflowy: "hidden",
    },
  });

  const getAllRequestData = async (Busunitdata) => {
    try {
      const requestItems = await fetchRequestListData(hideSampleData);
      // console.log(requestItems);
      allData = [];
      requestItems?.map((items) => {
        let _contracttypename = items.Contract_Type ? items.Contract_Type.split("|") : "";
        let contracttypeId = _contracttypename[1];
        let ContracttypeRowID = _contracttypename[0];
        let finaltemptwo: any = {
          contracttypeId: contracttypeId,
          Activity_Logs:JSON.parse(items.Activity_Log||"[]"),
          RequestType:items.RequestType,
          ContractType:items?.Contract_Type,
          Contract_Type:items?.Contract_Type,
          ContracttypeRowID: ContracttypeRowID,
          Guid_ID: items?.Guid_ID,
          approvalStatus: items.Status == "Rejected" ? "Rejected" : "In Progress",
          Counterparty_Name1: items?.Counterparty_Name,
          ID: items.ID,
          // status:approvalStatus,
          items: items,
          Request_Number1: items?.Request_Number,
          Title1: items.Title,
          BusinessUnit: Busunitdata[items?.Business_Unit] || "-",
          BusinessUnits:items?.Business_Unit,
          Contract_Start_Date: items.Contract_Start_Date
            ? moment(new Date(items.Contract_Start_Date)).format("MM/DD/YYYY")
            : "-",
          Contract_End_Date:
            items.Contract_End_Date != null && items.Contract_End_Date != ""
              ? moment(new Date(items.Contract_End_Date)).format("MM/DD/YYYY")
              : "-",
          // Contract_Type:contracttypename != "" ? tempcontracttype[_contracttypename[1]] : "";
        };
        allData.push(finaltemptwo);
      });
      setRequestData(allData);
    } catch (error) {
      console.log(error);
    }
  };

  const openPanel = (request, calloutId) => {
    console.log(request);
    setTaskData((c)=>({
      ...c,
      RequestData:request
    }))
    setisTaskOpen(true);
    setcalloutID(calloutId);
  };

  const onFormatDate = (date?: Date): string => {
    return !date ? "" : moment(new Date(date)).format("MM/DD/YYYY");
  };

  const onDismiss=()=>{
  setisTaskOpen(false);
  setTaskData({
    TaskTitle:"",
    DueDate:null,
    AssignedTo:[],
    AssignedToName:[],
    Remarks:"",
    RequestData:{}
  })
  }

  const createTask=async()=>{


    if(!isStringValidated(TaskData.TaskTitle)||TaskData?.TaskTitle?.trim()==""){
      SweetalertCallout('error','Please enter task title')
    }else if(!isArrayValidated(TaskData.AssignedToName)){
      SweetalertCallout('error','Please select assign to')
    }else if(!isStringValidated(TaskData.DueDate)){
      SweetalertCallout('error','Please select due date')
    }else{

  

    const uniqueGUID = uuid();
    const requestData:any=TaskData?.RequestData;
    const getUser:any = localStorage.getItem("CurrentUser");
    const CurrentUser=JSON.parse(getUser)
    let currentUserName=CurrentUser.currentUserName;
    let useremail=CurrentUser.currentUserEmail
    const taskTemplate={
      Title: TaskData.TaskTitle,
      ContractType: requestData.ContractType,
      RequestType: requestData.RequestType,
      Task_Type:TaskData.TaskTitle,
      TaskStage: "Additional",
      BusinessUnit: requestData.BusinessUnits,
      Status:"Not Started",
      DueDate: TaskData.DueDate,
      AssignedToId:TaskData.AssignedTo||"[]",
      RequestGuid:requestData.Guid_ID,
      Contract_Request_Title:requestData.Title1 ,
      TaskGuid: uniqueGUID.toString() || "",
    };

    const ActivityLogs = requestData?.Activity_Logs ||[]
    ActivityLogs.push({
      "Activity": "Task Created",
      "Description": `Task is created to ${TaskData?.AssignedToName.join(", ")} by ${currentUserName}.`,
      "CreatedOn":new Date(),
      "CreatedBy": currentUserName,
      "CreatedByEmail":useremail,
      "Reasons": "",
      "Remarks":TaskData?.Remarks ,
      "Attachments": "",
      "Approvers": [],
      "Originator": [
        currentUserName
      ],
      "receivedUser": [],
      "Contract_Type":requestData.ContractType
    })

    try{
      const token = localStorage.getItem("CurrentToken");
      const SiteURL = localStorage.getItem("SiteURL");
      const updateUrl = `${SiteURL}/_api/web/lists/getbytitle('CLM365ContractTasks')/items`;
      const response = await axios.post(updateUrl,taskTemplate, {
        headers: {
          Accept: "application/json;odata=nometadata",
          "Content-type": "application/json;odata=nometadata",
          "odata-version": "",
          Authorization: `Bearer ${token}`,
        },
      }).then((c)=>{
        const finalTemp={
          Activity_Log:JSON.stringify(ActivityLogs)
        }

        updateActivity(finalTemp,requestData?.ID)
        onDismiss()
        SweetalertsTask('success','Task created successfully')
        // setTimeout(() => {
        //   onDismiss()
        // }, 2000);
      }).catch((error)=>{
        console.log(error)
      })
    }catch(error){
    console.log(error)
    }
  }


  }

  async function updateActivity(finaltaskTemplate: any, requestId: string) {
    const SiteURL = localStorage.getItem("SiteURL");
    const updateUrl = `${SiteURL}/_api/web/lists/getbytitle('CLM365Request')/items('${requestId}')`;
    const token = localStorage.getItem("CurrentToken");
   await axios
      .post(updateUrl, finaltaskTemplate, {
        headers: {
          Accept: "application/json;odata=nometadata",
          "Content-type": "application/json;odata=nometadata",
          "odata-version": "",
          Authorization: `Bearer ${token}`,
          "IF-MATCH": "*", // For optimistic concurrency
          "X-HTTP-Method": "MERGE", // Indicates partial updates (MERGE operation)
        },
      })
      .then((response) => {
        if (response.status === 204) {
          console.log("Request Completed Successfully");
        } else {
          console.warn("Unexpected response status:", response.status);
        }
      })
      .catch((error) => {
        console.error("Error updating activity:", error);
      });
  }

  return (
    <div id="SweetalertsAddTask">
          <Label>Adhoc Task</Label>
      <div style={{ padding: "10px 0px" }} className="AdhocHeader" >
        <SearchBox
          styles={{root: { backgroundColor: "unset" }}}
          onChange={(c, newVal) => {
            setRequestData(
              newVal
                ? allData.filter(
                    (i) =>
                      i.Title1.toString().trim().toLowerCase().indexOf(newVal.toLowerCase()) > -1 ||
                      i.approvalStatus.toString().trim().toLowerCase().indexOf(newVal.toLowerCase()) > -1 ||
                      i?.Request_Number1?.toString()?.trim()?.indexOf(newVal) > -1 ||
                      i.Contract_End_Date.toString().trim().toLowerCase().indexOf(newVal.toLowerCase()) > -1 ||
                      i?.Contract_Start_Date?.toString()?.trim()?.indexOf(newVal) > -1 ||
                      i.BusinessUnit.toString().trim().toLowerCase().indexOf(newVal.toLowerCase()) > -1
                  )
                : allData
            );
          }}
          placeholder="Search"
        />
      </div>
      <div style={{ display: "flex", flexFlow: "column", gap: "5px" }}>
        {requestData?.map((request, index) => {
          return (
            <div
              key={index}
              style={{ border: "1px solid #ddd", background: "#fff", cursor: "pointer" }}
              onClick={() => {
                if (CurrentUser.currentUserRole !== 'Analyst') {
                  openPanel(request, `addTask${index + 1}`);
                }
              }}
              id={`addTask${index + 1}`}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "5px",
                  backgroundColor: "#F0F0F0",
                }}
              >
                <div style={{ fontSize: "13px", fontWeight: "600" }}>{request?.Title1}</div>
                <div
                  style={{
                    fontSize: "10px",
                    fontWeight: "600",
                    minWidth:'fit-content',
                    color:
                      request?.approvalStatus == "In Progress"
                        ? "#ffaa44"
                        : request?.approvalStatus == "Rejected"
                          ? "#c50f1f"
                          : request?.approvalStatus == "Completed"
                            ? "#6bb700"
                            : "#000",
                  }}
                >
                  {request?.approvalStatus}
                </div>
              </div>
              <div style={{ padding: "5px" }}>
                <div style={{ fontSize: "10px",fontWeight:'600' }}>{request?.Request_Number1}</div>
                {request?.BusinessUnit != "-" && (
                  <div style={{ fontSize: "10px" }}>
                    <span style={{ fontWeight: "600" }}>Business Unit: </span>
                    {request?.BusinessUnit}
                  </div>
                )}
                <div style={{display:'flex',justifyContent:'space-between'}}>
                <div style={{ fontSize: "10px" }}>
                  <span style={{ fontWeight: "600" }}>Start Date: </span>
                  {request?.Contract_Start_Date}
                </div>
                <div style={{ fontSize: "10px" }}>
                  <span style={{ fontWeight: "600" }}>End Date: </span>
                  {request?.Contract_End_Date}
                </div>
                </div>
        
              </div>
            </div>
          );
        })}

        {isTaskOpen && (
          <Callout
            className={stylesCallout.callout}
            preventDismissOnEvent={(ev) => {
              return true;
            }}
            role="dialog"
            gapSpace={0}
            target={`#${calloutID}`}
            onDismiss={onDismiss}
            setInitialFocus
            id="alertCallout"
            styles={{
              root: {
                height: "auto",
                maxHeight: "unset",
              },
            }}
            >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Label>Create Task</Label>

              <Dismiss32Filled onClick={onDismiss} style={{ height: "12px" }} />
            </div>

            <div style={{ marginTop: "5px" }}>
              <div style={{marginBottom:'7px'}}>
              <TextField placeholder="Enter Task Title" onChange={(c,newval)=>{
                setTaskData((c)=>({
                  ...c,
                  TaskTitle:newval
                }))
              }}></TextField>
              </div>
             
              <div style={{marginBottom:'7px'}}>
              <Select
                placeholder={"Select Assign To"}
                options={UserOptions}
                minMenuHeight={100}
                maxMenuHeight={140}

                value={UserOptions.filter((el) =>
                  TaskData?.AssignedTo.some((f) => f === el.key)
                )}
                isSearchable={true}
                isMulti
                onChange={(select) => {
                    setTaskData((c)=>({
                      ...c,
                      AssignedTo:select.map((e)=>e.key)||[],
                      AssignedToName:select.map((e)=>e.text)||[],
                    }))
                }}
                styles={customStyles}
              />
              </div>
          

              <DatePicker
              style={{marginBottom:'7px'}}
              showWeekNumbers={true}
              showMonthPickerAsOverlay={true}
                placeholder="Select Due Date"
                onSelectDate={(date) =>{
                    setTaskData((c)=>({
                      ...c,
                      DueDate:date
                    }))
                }
                 
                }
                // value={TaskData?.DueDate == undefined || TaskData?.DueDate == null ? null : new Date(TaskData?.DueDate)}
                value={
                  TaskData?.DueDate
                    ? new Date(TaskData?.DueDate)
                    : null
                }
                formatDate={onFormatDate}
              />
                   <div style={{marginBottom:'7px'}}>
              <TextField placeholder="Enter Remarks" onChange={(c,newval)=>{
                setTaskData((c)=>({
                  ...c,
                  Remarks:newval
                }))
              }} type="Note" 
              style={{ resize: 'none' }}
              
               multiline
              rows={3}></TextField>
              </div>
             
              <div style={{display:'flex',justifyContent:'center',gap:'8px',alignItems:'center',margin:'10px 0px'}}>
              <PrimaryButton onClick={createTask}>Submit</PrimaryButton>
              <DefaultButton onClick={onDismiss}>Cancel</DefaultButton>
              </div>
             
            </div>
          </Callout>
        )}
      </div>
    </div>
  );
}

export default AdhocTaskPane;
